import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, autofill, reduxForm } from "redux-form";
// import "./styles.css";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import Util from "../../../Common/util";
import API from "../../../Common/api";

import "./styles_inbound.css";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import DatePicker from "react-datepicker";
import { PostAddTwoTone } from "@material-ui/icons";

import { useMemo, useState } from 'react'
import { useTable, usePagination ,useGlobalFilter} from 'react-table'
import { useAsyncDebounce } from 'react-table'
// import 'bootstrap/dist/css/bootstrap.min.css';
import { Hidden } from "@material-ui/core";
import { color } from "highcharts";

const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;

var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;
var today_date;
var tomm_date;

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = (csvData,GROUPED_COLUMNS, fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [
    ["","","","","","","","","","JARVIS","JARVIS","JARVIS","ERP","ERP","ERP"],
    [
      "City",	"Warehouse",	"Brand",	"PO Date",	"PO No","Invoice No","Inbound Type",	"PO Qty",	"PO Value",	"GRN Date",	"GRN Qty",	"GRN Value",	"GRN Date",	"GRN Qty",	"GRN Value",	"ERP Integration Status"	,"Failure reason"
    ],
  ];
  // const Heading = GROUPED_COLUMNS;
  const ws = XLSX.utils.json_to_sheet(csvData, {
    origin: "A3",
    skipHeader: true,
  });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: "A1" });
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };
  

  constructor() {
    super();

    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchInventory = this.fetchInventory.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      filtered_orderData: [],
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      fileNameVal: "masterFile",
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,

      isLoading: true,
      showFetchBinData: false,
      show_process_data: true,

      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      selectedSubGroup: "",
      error_modal : false,
      warehouse_code : "",
      brand_code:"",
      clientData: "",
      warehouseData : "",
      visible : "hidden",
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""

    };

  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    this.fetchWarehouseData();
    this.fetchBrandData();
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (
      window.location.port == 8098 ||
      window.location.port === ":8098"
    ) {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    
    this.setState({
      userName: cookieUsername,
      selectedLocation: location,
    });

    localStorage.setItem("userName", username);
  }

  convertDate = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join("-");
  };
  convertDate1 = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [pad(d.getDate()-1), pad(d.getMonth() + 1), d.getFullYear()].join("-");
  };
  convertDate2 = (inputFormat) => {
    function pad(s) {
      return s < 10 ? "0" + s : s;
    }
    var d = new Date(inputFormat);
    return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join("-");
  };
  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });

    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };
  /*FromDateChange = (date) => {
    this.setState({
      fromdate: date,
      showFromErr: false,
    });
    if (date) {
      From_Date_val = this.convertDate(date);
      tomm_date = this.convertDate2(date);
      today_date = this.convertDate1(date);
    } else {
      this.setState({
        fromdate: "",
      });
      From_Date_val = "";
    }
  };

  ToDateChange = (date) => {
    this.setState({
      todate: date,
      showToErr: false,
    });
    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({
        todate: "",
      });
      to_Date_val = "";
    }
  };*/
  ChangeVisibility = () =>{
    this.setState ({
      visible : "hidden"
    })
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
    document.cookie =
      cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

  handleSubGroupChange = (e) => {
    const value = e.target.value;
    this.setState({
      selectedSubGroup: value,
    });
  };
  onwarehouseChange = (evt) => {

    this.setState({
      warehouse_code: evt.target.value
    })

  }

  onBrandChange = (evt) => {

    this.setState({
      brand_code: evt.target.value
    })

  }
  fetchWarehouseData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        console.log(data)

        this.setState({
          //showFetchDispatchData: true,
          warehouseData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchBrandData = () => {

    const payload = {


    };

    API.post('/product/product_master/v1/client/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        console.log(data)

        this.setState({
          //showFetchDispatchData: true,
          clientData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }
  fetchInventory() {

    if (From_Date_val === undefined && to_Date_val === undefined && this.state.selectedSubGroup == ""){
      this.setState({error_modal : true})
    }
    else {
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay: true,
      });

    const payload = {
    
      "fromdate": From_Date_val,
      "todate"  : to_Date_val,
      "warehouse": this.state.warehouse_code,
      "brand": this.state.brand_code
    };
    API.post("/mis/inbound-failure-records/v1/product", { param: payload })
      .then((response) => response.data)

      .then((data) => {
        // this.setState({ posts: data.data, filtered_orderData: data.data });
        this.setState ({tableRows: this.assemblePosts(data.data), showFetchBinData: true,visible:"visible"});
        
      })

      .then(async () => {
        this.setState({  isLoading: false });

    
      });
  }}
  errorModaltoggle = () => {
    this.setState({error_modal :false})
  }
  filterData = (evt) => {
    
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.posts });
    } else {
      var value = this.state.posts.filter((val) => {
        return Object.keys(val).some((key) => {
          var data = "";
          if (val[key] == null) {
            data = "";
          } else {
            data = val[key];
          }

          return data.toString().toLowerCase().includes(evt.toLowerCase());
        });
      });

      this.setState({
        filtered_orderData: value,
      });
    }
  };

  assemblePosts = (data) => {
    let posts = data.map((post) => {
      var status = "";
      if (post.status == true) {
        status = "Active";
      } else {
        status = " Not Active";
      }
      return {
        city : post.city,
        warehouse: post.warehouse,
        brand : post.brand,
        po_date : post.po_date,
        po_no : post.po_no,
        invoice_no : post.invoice_no,
        inbound_type : post.inbound_type,
        po_qty : post.po_qty,
        po_value : post.po_value,
        jarvis_grn_date : post.jarvis_grn_date,
        jarvis_grn_qty : post.jarvis_grn_qty,
        jarvis_grn_value : post.jarvis_grn_value,
        erp_grn_date : post.erp_grn_date,
        erp_grn_qty : post.erp_grn_qty,
        erp_grn_value:post.erp_grn_value,
        erp_status : post.erp_status,
        failure_reason : post.failure_reason    
        
      };
    });

    this.setState({
      loading_overlay: false,
      filtered_orderData : posts,
      posts              : posts,
    });
  

    return posts;
  };

  processData() {
    this.setState({
      loading: true,
    });
  }
  
  render() {
    
    
    const GROUPED_COLUMNS = [  
        {
          Header: 'City',
          accessor: 'city'
        },
        {
          Header: 'Warehouse',
          accessor: 'warehouse'
        },
        {
          Header: 'Brand',
          accessor: 'brand'
        },
        {
          Header : "PO Date",
          accessor : "po_date"
        },
        {
          Header : "PO No",
          accessor :  "po_no"
        },
        {
          Header : "Invoice No",
          accessor :  "invoice_no"
        },
        {
          Header : "Inbound Type",
          accessor :  "inbound_type"
        },
        {
          Header : "PO Qty",
          accessor :  "po_qty"
        },
        {
          Header : "PO Value",
          accessor :  "po_value"
        },
        {Header : "JARVIS",
         columns : [{
          Header : "GRN Date",
          accessor :  "jarvis_grn_date"
        },
        {
          Header : "GRN Qty",
          accessor :  "jarvis_grn_qty"
        },
        {
          Header : "GRN Value",
          accessor :  "jarvis_grn_value"
        } ] },
        {Header : "ERP",
        columns:[{
          Header : "GRN Date",
          accessor :  "erp_grn_date"
        },
        {
          Header : "GRN Qty",
          accessor :  "erp_grn_qty"
        },
        {
          Header : "GRN Value",
          accessor :  "erp_grn_value"
        }]},
        {
          Header : "ERP Integration Status",
          accessor :  "erp_status"
        },
        {
          Header : "Failure reason",
          accessor :  "failure_reason"
        }    
     
    ]
  
    const GlobalFilter = ({ filter, setFilter }) => {
      const [value, setValue] = useState(filter)
      const onChange = useAsyncDebounce(value => {
        setFilter(value || undefined)
      }, 1000)
      return (
        <span >
          {' '}
          <input  className="input_border"
            value={value || ''}
            placeholder="Search"
            onChange={e => {
              setValue(e.target.value);
              onChange(e.target.value);
            
            }}
          />
        </span>
      )
    }
    const PaginationTable = () => {
      const columns = useMemo(() => GROUPED_COLUMNS, [])
      const data = useMemo(() => this.state.posts, [])
    
      const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        page,
        nextPage,
        previousPage,
        canPreviousPage,
        canNextPage,
        pageOptions,
        state,
        setGlobalFilter,
        gotoPage,
        pageCount,
        setPageSize,
        prepareRow
      } = useTable(
        {
          columns,
          data,
          initialState: { pageIndex: 0 ,pageSize: 15},        
        },
        useGlobalFilter,
        usePagination,       
      )
    
      const { pageIndex, pageSize,globalFilter } = state
    
      return (
        <>
        <div style={{textAlign:"right", paddingBottom:"5px",marginTop:"-10px"}}><GlobalFilter filter={globalFilter} setFilter={setGlobalFilter}/></div>
      <table className ="cc_table" style ={{width:"100%"}}{...getTableProps()}>
        <thead >
          
          {headerGroups.map(headerGroup => {
            return(
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => {
                if(column['Header'] == "JARVIS"){ return(
                  <th  style={{backgroundColor : "rgb(255,192,0)"}}{...column.getHeaderProps()}>{column.render('Header')}</th>)
                }
                else if(column['Header'] == "ERP"){
                return(
                <th style={{backgroundColor:"rgb(142,169,219)",}} {...column.getHeaderProps()}>{column.render('Header')}</th> 
              )}
              else{
                return(
                  <th {...column.getHeaderProps()}>{column.render('Header')}</th> 
                )
              }
              })}           
            </tr>
          )})}
         
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map(row => {
            prepareRow(row)
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  if(cell['value'] == "True"){
                    // alert("true");
                    return <td style={{border:"1px solid white",fontWeight : "bold",backgroundColor:"rgb(169,208,142)"}}{...cell.getCellProps()}>Pass</td>
                  }
                  else if(cell['value'] == "False"){
                    return <td style={{border:"1px solid white",fontWeight : "bold",backgroundColor:"red"}}{...cell.getCellProps()}>Fail</td>
                  }

                  else{
                    
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  }
                  
                })}
              </tr>
            
            )
          })}
        </tbody>
        
      </table>
      
      <div className="pagination__style" style={{textAlign:"center",margin : "10px 0px 1px 0px"}}>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          Prev
        </button>{' '}
        <span>
          {/* Page{' '} */}
          <strong>
            {pageIndex + 1} {/*of {pageOptions.length}*/}
          </strong>{' '}
        </span>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          Next
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
       
        {/* <span>
          | Go to page:{' '}
          <input
            type='number'
            defaultValue={pageIndex + 1}
            onChange={e => {
              const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0
              gotoPage(pageNumber)
            }}
            style={{ width: '50px' }}
          />
        </span>{' '} */}
        <select
          value={pageSize}
          onChange={e => setPageSize(Number(e.target.value))}>
          {[20, 40, 60, 80].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> 
      </div>
    </>

      )
    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            ></LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <CardBody
            style={{
              paddingTop: 10,
              height: 70,
              paddingBottom: 0,
              marginBottom: "-13px",
              marginTop:"0px"
            }}
          >
            <form className="form">
             
              <div
                style={{
                  width: "15%",
                  marginBottom: "0px",
                  float: "left",
                  marginRight: 5,
                }}
              >
                <DatePicker
                  selected={this.state.from_date}
                  onChange={this.FromDateChange}
                  className="ledger_fromdate"
                  placeholderText="Select From Date"
                  format="yyyy-MM-dd"
                  onInputClick = {this.ChangeVisibility}
                />
                {this.state.showFromErr && (
                  <span style={{ color: "red", fontSize: 11 }}>
                    Please Select Date
                  </span>
                )}
                {this.state.dateOrderError && (
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                )}
              </div>
              <div
                style={{
                  width: "15%",
                  marginBottom: "0px",
                  float: "left",
                  marginRight: 5,
                }}
              >
                <DatePicker
                  selected={this.state.to_date}
                  onChange={this.ToDateChange}
                  className="ledger_fromdate"
                  placeholderText="Select To Date"
                  format="yyyy-MM-dd"
                  onInputClick = {this.ChangeVisibility}
                />
                {this.state.showFromErr && (
                  <span style={{ color: "red", fontSize: 11 }}>
                    Please Select Date
                  </span>
                )}
                {this.state.dateRangeError &&
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                }
              </div>
              <div
                style={{ width: '16%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control"
                    style={{ fontSize: 13, width: 190 }}
                    onChange={this.onwarehouseChange}
                  >
                    <option value="">Select warehouse</option>
                    {
                      this.state.warehouseData.length > 0 &&
                      this.state.warehouseData.map((warehouseData) => {
                        return (
                          <option value={warehouseData.name}>{warehouseData.name} </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                style={{ width: '16%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
                  <select
                    className="form-control"
                    style={{ fontSize: 13, width: 190 }}
                    onChange={this.onBrandChange}
                  >
                    <option value="">Select Brand</option>
                    {
                      this.state.clientData.length > 0 &&
                      this.state.clientData.map((clientData) => {
                        return (
                          <option value={clientData.name}>{clientData.name} </option>
                        );
                      })}
                  </select>
                </div>
              </div>
           

              <div
                style={{
                  width: "9%",
                  marginBottom: "0px",
                  marginLeft: "60px",
                  float: "left",
                }}
              >
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchInventory()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View
                  </Button>
                </ButtonToolbar>
              </div>
              <div className="download_excel_style" style={{ width: "6%", marginBottom: "0px", float: "left" }}>
              <button
                  type="button"
                  style={{backgroundColor: '#fff', border: 0}}
                  // onClick={this.downloadReport}
                >
                  {/* <img
                    src={require("../../../../images/download.png")}
                    onClick={this.state.downloadError}
                  /> */}
                  <img
                    src={require("../../../../images/download.png")}
                    onClick={(e) =>
                      exportToCSV(
                        this.state.filtered_orderData,GROUPED_COLUMNS,
                        "Inbound Failure Report"
                      )
                    }
                  />
                </button>
              </div>
            </form>
          </CardBody>
          {/* <CardBody style={{
              paddingTop: 10,
              height: 70,
              paddingBottom: 0,
              marginBottom: "-13px",
              marginTop:"0px"
            }}></CardBody> */}
          {this.state.showFetchBinData && (
            <CardBody style={{ marginTop: 20 ,height:"auto",visibility: this.state.visible}}>
             
              
              <PaginationTable/>
              
            </CardBody>
          )}
          
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
